import React from 'react'
import YachtSlider from './YachtSlider'
import { Modal, Button } from "react-bootstrap";
import BookNowButton from './BookNowButton';

const YachtModal = ({ yacht, show, handleClose }) => {
    if (!yacht) return null;
    return (
        <>
            <Modal show={show} onHide={handleClose} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{yacht.yacht_name} - Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <YachtSlider yachtImages={yacht.images} />
                            </div>

                            <div className="col-md-6 mt-md-0 mt-3">
                                <h3 className="mb-3">{yacht.yacht_name}</h3>
                                {/* <h3>Location {yacht.location}</h3> */}
                                <p><strong>Capacity:</strong> {yacht.passenger_capacity} People</p>
                                {/* <p><strong>Overnight capacity:</strong> 4 People</p> */}
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col">Description</th>
                                            <th scope="col">Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {yacht.price_details.map((price) => (
                                            <tr>
                                                <td>{price.hours}</td>
                                                <td>${price.price}</td>
                                            </tr>
                                        ))}
                                       
                                    </tbody>
                                </table>

                                <p>
                                   {yacht.short_description}
                                </p>
                                {/* <button className="book-btn py-2" style={{ "backgroundColor": "transparent", "padding": "10px 20px", "borderRadius": "30px" }}>Book Now</button> */}
                                <BookNowButton buttonText="Book Now" buttonClass="yacht-modal-book-btn" yachtId={yacht.id} yachtName={yacht.yacht_name} />
                                <button className="book-btn py-2"
                                    style={{ "backgroundColor": "#25d366", "marginLeft": "10px", "padding": "10px 20px", "borderRadius": "30px" }}>
                                    Whatsapp
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}

export default YachtModal